import { validateAddress } from '@debbie/common/dist/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useStreetView } from '@debbie/cortex/dist/street-view/index.js';
import React from 'react';
const StreetView = (props) => {
    const hasAddress = validateAddress(props.address);
    const loadable = useStreetView(hasAddress ? props.address : null);
    const image = h.hasData(loadable) ? loadable.data.image : null;
    return (React.createElement("div", { style: {
            overflow: 'hidden',
            display: 'inline-block',
            width: props.width || '300px',
            borderRadius: '3px',
            ...props.style,
        } }, image === null ? null : (React.createElement("img", { style: {
            width: props.width || '300px',
            marginBottom: '-30px',
        }, src: image }))));
};
export default StreetView;
//# sourceMappingURL=StreetView.js.map